import { getAttributes } from '@tiptap/core';
import { MarkType } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { isInternalLink } from '@/utilities/internalLink';

type ClickHandlerOptions = {
  type: MarkType;
  emitter: any;
  editor: any;
};

export function clickHandler(options: ClickHandlerOptions): Plugin {
  return new Plugin({
    key: new PluginKey('handleClickLink'),
    props: {
      handleClick: (view, pos, event: MouseEvent) => {
        if (event.button !== 0) return false;

        const link = findLinkElement(event.target as HTMLElement);
        if (!link || link.nodeName.toLowerCase() !== 'a') return false;

        const attrs = getAttributes(view.state, options.type.name);
        const href = link?.href ?? attrs.href;
        const target = link?.getAttribute('target') ?? attrs.target;

        if (shouldHandleInternalLink(href)) {
          options.emitter.$emit('scrollToAnchor', { editorId: options.editor.id, url: href });
          return false;
        }

        if (href) {
          if (view.editable) {
            window.open(href, target);
          }
          return true;
        }

        return false;
      },
    },
  });
}

export function findLinkElement(element: HTMLElement): HTMLLinkElement | null {
  if (element.nodeName.toLowerCase() === 'a') {
    return element as HTMLLinkElement;
  }

  if (element.closest('.embedded-board')) {
    return null;
  }

  let currentElement = element.parentElement;
  while (
    currentElement?.parentElement &&
    currentElement?.getAttribute?.('data-block-id') === null
  ) {
    if (currentElement?.nodeName.toLowerCase() === 'a') {
      return currentElement as HTMLLinkElement;
    }
    currentElement = currentElement?.parentElement || null;
  }

  return element as HTMLLinkElement;
}

export function shouldHandleInternalLink(href: string): boolean {
  if (!isInternalLink(href)) return false;

  const urlFromHref = new URL(href);
  return urlFromHref.pathname === window.location.pathname;
}
